import { render, staticRenderFns } from "./stock_record.vue?vue&type=template&id=41e7a2f4&scoped=true"
import script from "./stock_record.vue?vue&type=script&lang=js"
export * from "./stock_record.vue?vue&type=script&lang=js"
import style0 from "./stock_record.vue?vue&type=style&index=0&id=41e7a2f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e7a2f4",
  null
  
)

export default component.exports